var map = {
	"./": 70221,
	"./akros.png": 98743,
	"./allianz.svg": 77289,
	"./americanexpress.svg": 42050,
	"./barclays.svg": 1311,
	"./bcc.svg": 10155,
	"./bim.png": 93620,
	"./bnl.svg": 6248,
	"./bper.png": 71426,
	"./bpm.svg": 60052,
	"./carige.png": 84839,
	"./cartalis.png": 77775,
	"./cento.png": 9310,
	"./chebanca.svg": 37858,
	"./cinque.svg": 68735,
	"./civibank.png": 36872,
	"./compass.png": 77782,
	"./credem.svg": 70612,
	"./creditagricole.svg": 98081,
	"./creval.png": 1696,
	"./default_logo.png": 68058,
	"./default_logo.svg": 77780,
	"./delsud.png": 52986,
	"./depobank.png": 88486,
	"./desio.svg": 36268,
	"./euromobiliare.svg": 29777,
	"./farbanca.png": 81133,
	"./fideuram.svg": 91381,
	"./findomestic.png": 41121,
	"./fineco.svg": 39071,
	"./friulandria.png": 77589,
	"./fucino.png": 95442,
	"./galileo.png": 80067,
	"./generali.svg": 88844,
	"./guber.png": 89690,
	"./hello.svg": 92429,
	"./hype.svg": 17621,
	"./ibl.png": 18124,
	"./ifis.png": 68373,
	"./illimity.png": 83102,
	"./index": 70221,
	"./index.jsx": 70221,
	"./ing.svg": 50106,
	"./intesa.svg": 22790,
	"./iwbank.png": 93325,
	"./mediobanca.png": 55914,
	"./mediolanum.svg": 66159,
	"./mps.svg": 36327,
	"./n26.svg": 4688,
	"./nexi.svg": 13080,
	"./passadore.svg": 8940,
	"./piemonte.png": 58235,
	"./poste.svg": 78459,
	"./postepay.svg": 87818,
	"./santander.png": 47261,
	"./sardegna.svg": 7242,
	"./sella.svg": 49346,
	"./sondrio.svg": 94639,
	"./spoleto.png": 60451,
	"./ubi.svg": 94825,
	"./ubs.svg": 37036,
	"./unicredit.svg": 38038,
	"./unipol.png": 22491,
	"./widiba.svg": 19568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84321;